/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



// WEBPACK FOOTER //
// webpack://paypal/(webpack)/buildin/amd-options.js